var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 28.125H16.875C17.3721 28.1245 17.8488 27.9268 18.2003 27.5753C18.5518 27.2238 18.7495 26.7471 18.75 26.25V23.4375H16.875V26.25H5.625V3.75H16.875V6.5625H18.75V3.75C18.7495 3.25287 18.5518 2.77625 18.2003 2.42472C17.8488 2.0732 17.3721 1.8755 16.875 1.875H5.625C5.12787 1.8755 4.65125 2.0732 4.29972 2.42472C3.9482 2.77625 3.7505 3.25287 3.75 3.75V26.25C3.7505 26.7471 3.9482 27.2238 4.29972 27.5753C4.65125 27.9268 5.12787 28.1245 5.625 28.125Z",
    fill: "#CC3A2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2994 19.2994L22.6613 15.9375H9.375V14.0625H22.6613L19.2994 10.7006L20.625 9.375L26.25 15L20.625 20.625L19.2994 19.2994Z",
    fill: "#CC3A2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.a09fdb2d6074f30c0887b64623235bc1.svg";
export { ForwardRef as ReactComponent };